module.exports = __webpack_public_path__ + "img/46.4c2f3ecb.webp";